import { DatePipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import Swal from 'sweetalert2';
import { toSignal } from '@angular/core/rxjs-interop';
import { TegelModule } from '@scania/tegel-angular-17';
import { interval, map, startWith } from 'rxjs';
import { FullReservation } from '../../core/models/reservation/full-reservation';
import { ReservationService } from '../../core/services/application/flexseat/reservation.service';
import { DateService } from '../../core/services/application/util/date/date.service';
import { GraphService } from '../../core/services/application/util/graph/graph.service';

@Component({
  selector: 'app-checkin',
  imports: [TegelModule, DatePipe],
  templateUrl: './checkin.component.html',
  styleUrl: './checkin.component.scss'
})
export class CheckinComponent{

  private readonly reservationService = inject(ReservationService);
  private readonly graphService = inject(GraphService);
  private readonly dateService = inject(DateService);

  data = this.reservationService.userTodayReservation;

   today(): string {
    const now = this.dateService.getCurrentDate();
    return now.toISOString().split('T')[0]; // Returns only YYYY-MM-DD
  }

  
  /** 
   * Converts Observable directly to signal
  */
  currentTime = toSignal(
    interval(1000).pipe(
      map(() => this.dateService.getCurrentDate()),
      startWith(this.dateService.getCurrentDate()) // Initial value
    ),
    { initialValue: this.dateService.getCurrentDate() }
  );

  /** Computed to determinate the time status
   * Checks if its near the time for the check in to expire or not
   */
  timeStatus = computed(() => {
    const date = this.currentTime();
    if (!date) return 'normal';
    
    const timeDecimal = date.getHours() + (date.getMinutes() / 60);
    
    if (timeDecimal >= 8.5 && timeDecimal < 9) return 'danger';
    if (timeDecimal >= 7.5 && timeDecimal < 8.5) return 'warning';
    return 'normal';
  });

  /** Computed to determined if it has to show the icon */
  showWarningIcon = computed(() => this.timeStatus() !== 'normal');
    
    /**  Computed signals */
    hours = computed(() => 
      this.currentTime().getHours().toString().padStart(2, '0')
    );
    
    minutes = computed(() => 
      this.currentTime().getMinutes().toString().padStart(2, '0')
    );
    
    seconds = computed(() => 
      this.currentTime().getSeconds().toString().padStart(2, '0')
    );
  
  /**  Bonus: Time full formated */
  formattedTime = computed(() => 
    `${this.hours()}:${this.minutes()}:${this.seconds()}`
  );

  /** Confirms checkin */
  async executeCheckin(reservation: FullReservation) {
    try {
      await this.reservationService.checkInReservationMethod(reservation);
    } catch (error) {
      console.error('Erro ao realizar check-in:', error);
    }
  }
  
  /** Cancels the reservation */
  async cancelReservation(reserva: FullReservation) {
    const result = await Swal.fire({
      title: 'Deseja cancelar a reserva?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    });

    if (result.isConfirmed) {
      try {
        await this.reservationService.cancelReservationMethod(reserva, this.graphService.userGraphData()!.employeeId);
        await Swal.fire({ icon: 'success', title: 'Reserva cancelada com sucesso!' });
      } catch (error) {
        console.error('Erro ao cancelar reserva:', error);
        await Swal.fire({ icon: 'error', title: 'Erro ao cancelar reserva', text: 'Tente novamente.' });
      }
    }
  }

}
